<template>
    <div class="company-member">
        <VJoyDropdownList
            :model-value="model?.identityRef.identityId"
            :options="options"
            class="company-member-dropdown-list"
            width="100%"
            @update:model-value="handleSelectionUpdate"
        >
            <template #label="option">
                <div class="company-member-dropdown-list__option">
                    <VJoyRadio :model-value="model?.identityRef.identityId" :value="option.id" class="company-member-dropdown-list__option__radio" />
                    <VJoyAvatar
                        :full-name="option.label"
                        :photo-url="option.photoUrl"
                        size="small"
                        class="company-member-dropdown-list__option__avatar"
                    />
                    <span class="company-member-dropdown-list__option__label">
                        {{ option.label }}
                    </span>
                    <span v-if="option.companyName" class="company-member-dropdown-list__option__company-name">
                        {{ option.companyName }}
                    </span>
                </div>
            </template>
        </VJoyDropdownList>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {Photo} from '@malt/asset-utils';
    import {VJoyDropdownList, VJoyAvatar, VJoyRadio} from '@maltjoy/core-vue';
    import type {ClientUserResource} from '@api';

    const emit = defineEmits(['item-selected']);

    const props = defineProps<{
        members: ClientUserResource[];
    }>();

    const model = defineModel<ClientUserResource>();

    const options = computed(() =>
        props.members.map((member) => ({
            id: member.identityRef.identityId,
            label: member.name,
            photoUrl: member.photo && new Photo(member.photo).getSimpleThumbnailUrl({width: 60, height: 60}),
            companyName: member.companyName,
        })),
    );

    function handleSelectionUpdate(selectedOptionId?: string) {
        model.value = props.members.find((member) => member.identityRef.identityId === selectedOptionId);

        emit('item-selected');
    }
</script>

<style scoped lang="scss">
    .company-member-dropdown-list {
        position: absolute;
        width: 100%;
        min-height: 48px;

        &__option {
            display: flex;
            align-items: center;
            column-gap: var(--joy-core-spacing-2);

            &__radio {
                margin: 0 var(--joy-core-spacing-1) 0 0;
            }

            &__avatar {
                margin-right: var(--joy-core-spacing-3);
            }

            &__label {
                flex-grow: 1;
            }

            &__company-name {
                color: var(--joy-color-neutral-40);
            }
        }

        // @FIXME: Display an empty state. Need a DS feature.
        :deep(.joy-dropdown-list__items:empty) {
            padding: var(--joy-core-spacing-3) var(--joy-core-spacing-4);

            &:after {
                content: 'No results found';
            }
        }
    }
</style>
